import React, { useEffect, useState } from 'react';
import api from 'api';
import PosContentsProduct from './PosContentsProduct';
import PosContentsProductEmpty from './PosContentsProductEmpty';
import PosCalculator from './PosCalculator';
import PosContentUserInfo from './PosContentUserInfo';
import { API } from 'common/config-api';
import UserTabPurchase from '../user/UserTabPurchase';

/**
 * POS 콘텐츠 컴포넌트
 * 바코드 입력, 상품 목록, 사용자 정보를 표시합니다.
 */
const PosContents = () => {
  const apiUrl = `${API.BASE_URL}`;

  // 상태 관리
  const [barcodeVal, setBarcodeVal] = useState('');
  const [productList, setProductList] = useState([]);
  const [userInfo, setUserInfo] = useState({
    userIdx: 0,
    userCode: '',
    userGrade: '',
    userNickname: '',
    userType: '',
    userPoint: 0,
    userAttendance: 0,
    userPurchase: 0
  });
  const [showUserPurchase, setShowUserPurchase] = useState(false);

  /**
   * 바코드로 상품 또는 회원 정보 조회
   */
  const getProductList = async (productBarcode) => {
    if (!productBarcode) return;

    try {
      const resp = await api.get(`${apiUrl}/sales/code/${productBarcode}`);
      const data = resp.data;

      if (data.infoType === 'product') {
        setBarcodeVal('');
        editProductQuantityAdd(data.product);
      } else if (data.infoType === 'user') {
        setUserInfo(data.user);
        setShowUserPurchase(true);
        setBarcodeVal('');
      } else if (data.infoType === 'null') {
        alert('해당 바코드에 매칭되는 회원/상품이 없습니다.');
        setBarcodeVal('');
      }
    } catch (error) {
      console.error('상품 조회 실패:', error);
      alert('상품 조회 중 오류가 발생했습니다.');
    }
  };

  /**
   * 상품 수량 추가 또는 신규 상품 추가
   */
  const editProductQuantityAdd = (productObj) => {
    const newProduct = { ...productObj, salesProductQuantity: 1 };

    if (productList.length > 0) {
      const tempArr = [...productList];
      let isOverlap = false;

      tempArr.forEach((arr) => {
        if (arr.salesProductQuantity === 0) {
          arr.salesProductQuantity = 1;
        }
        if (arr.productIdx === productObj.productIdx) {
          arr.salesProductQuantity = arr.salesProductQuantity + 1;
          isOverlap = true;
        }
      });

      if (isOverlap) {
        setProductList(tempArr);
      } else {
        setProductList([...tempArr, newProduct]);
      }
    } else {
      setProductList([newProduct]);
    }
  };

  /**
   * 상품 검색 실행
   */
  const searchProduct = () => {
    getProductList(barcodeVal);
  };

  /**
   * 바코드 입력값 변경
   */
  const handleBarcodeChange = (e) => {
    setBarcodeVal(e.target.value);
  };

  /**
   * Enter 키 입력 시 상품 검색
   */
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      searchProduct();
    }
  };

  return (
    <>
      <div className="col-lg-8">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">바코드 입력</h5>
            <div className="row mb-3">
              <div className="col-sm-8">
                <input
                  type="text"
                  className="form-control"
                  value={barcodeVal}
                  onChange={handleBarcodeChange}
                  onKeyDown={handleKeyDown}
                  placeholder="바코드 직접입력"
                />
              </div>
              <div className="col-sm-4">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={searchProduct}
                >
                  입력
                </button>
              </div>
            </div>

            <PosContentUserInfo u={userInfo} />

            <h5 className="card-title">구매상품 list</h5>

            <table className="table">
              <thead>
                <tr>
                  <th scope="col" width="70%">상품정보</th>
                  <th scope="col" width="10%" style={{ textAlign: 'right' }}>수량</th>
                  <th scope="col" style={{ textAlign: 'right' }}>가격</th>
                </tr>
              </thead>
              <tbody>
                {productList.length === 0 ? (
                  <PosContentsProductEmpty />
                ) : (
                  productList.map((value, index) => (
                    <PosContentsProduct
                      key={value.productIdx || index}
                      product={value}
                      setProduct={(value) => setProductList(value)}
                    />
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {showUserPurchase && (
          <div className="card" id="userPurchase">
            <div className="card-body">
              <h5 className="card-title">최근 구매내역</h5>
              {userInfo.userIdx > 0 && <UserTabPurchase idx={userInfo.userIdx} />}
            </div>
          </div>
        )}
      </div>

      <PosCalculator productList={productList} userInfo={userInfo} />
    </>
  );
};

export default PosContents;
